/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useRef,
  createContext,
  useContext,
  useMemo,
} from 'react';
import { css, jsx } from '@emotion/core';
import editorContext from '../editorContext';
import Separator from 'components/UI/Separator';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { colors } from 'styles/variables';
import setBlock from 'services/apiHelpers/setBlockProps';
import getMediaParent from 'services/apiHelpers/getMediaParent';
import getBlockById from 'services/apiHelpers/getBlockById';
import setBlockProps from 'services/apiHelpers/setBlockProps';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import FileUploader from 'components/UI/FileUploader';
import SetMediaType from 'components/Editor/SetMediaType';
import { cloneBlock } from '@chameleoncreator/creator-client/build/models/block';
import ImageLibrary from './ImageLibrary';
// import YourLibrary from './ImageLibrary/YourLibrary';
import EditorBtn from 'components/UI/EditorBtn';
import CheckBox from 'components/UI/CheckBox';
import { SingleColumnElement } from '../EditorUtilities/grid';
import SwitchWithLabel from '../EditorUtilities/SwitchWithLabel';
import ColorPickerWithLabel from '../EditorUtilities/ColorPickerWithLabel';
import NumberPickerWithLabel from '../EditorUtilities/NumberPickerWithLabel';
import { Flexbox, Box } from '@chameleoncreator/creator-ui';
import imageUploadError from 'assets/imageUploadError.svg';
import getStore from 'services/getStore';

// updated UI
import { H1 as H1_v2, H2 as H2_v2 } from '../EditorUtilities/UI/Headings';
import TogglePanel from '../EditorUtilities/UI/TogglePanel';
import CheckBox_v2 from '../EditorUtilities/UI/CheckBox';
import Button from '../EditorUtilities/UI/Button';
import NumberPicker_v2 from '../EditorUtilities/UI/NumberPicker';
import ColorPicker_v2 from '../EditorUtilities/UI/ColorPicker';
import Info from '../EditorUtilities/UI/Info';
import {
  isFeatureEnabled,
  FeatureFlag,
} from '../../../services/isFeatureEnabled';
import Modal from 'components/UI/Modal';
import CloseBtn from 'components/UI/CloseBtn';
import { InputRow } from 'components/lib/EditableText/LinkModal/Inputs';
import helpers from 'components/lib/EditableText/LinkModal/helpers';
import ModuleNavigation from 'components/Editor/ModuleGlobalNavigation/ModuleGlobalNavigation';
import getLocationName from 'services/getLocationName';

interface IImageLibraryContext {
  currentImageSrc: string;
  currentImageId: string | number;
  onAddImage?: ({}: any) => void;
  onClose?: () => void;
  cacheSelected?: { [key: string]: any };
  cacheFilter?: { [key: string]: any };
}

const ImageLibraryContext = createContext<IImageLibraryContext | undefined>(
  undefined
);

const { lGrey0, lGrey1, mint } = colors;

const { getState } = getStore();

const Panel = ({ title, info = '', children, ...props }) => {
  return (
    <div
      css={css`
        margin: 20px 0 0 0;
      `}
      {...props}
    >
      <div
        css={css`
          margin: 0 0 5px 0;
        `}
      >
        {!info ? <H2_v2>{title}</H2_v2> : <Info info={info}>{title}</Info>}
      </div>
      {children}
    </div>
  );
};

const Input = ({ defaultValue, update }) => {
  return (
    <input
      type="text"
      defaultValue={defaultValue}
      css={css`
        width: 100%;
        margin: 0 0 10px 0;
        padding: 10px;
        border: 1px solid ${lGrey1};
        outline: none;
        resize: none;
        font-family: 'Poppins';
        font-size: 12px;
      `}
      onKeyUp={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          update(e.currentTarget.value);
        }
      }}
      onBlur={e => {
        e.preventDefault();
        update(e.currentTarget.value);
      }}
    />
  );
};

const ImageLibraryBtn = ({ imageLibrary, setImageLibrary }) => {
  return (
    <EditorBtn
      label="Insert image"
      style={{
        width: `${'175px' || '100%'}`,
        // height: 35,
        // height: '31px !important',
        margin: '0 0 15px 0',
        border: `1px solid ${lGrey0}`,
        background: '#fff',
        color: lGrey0,
        fontSize: 11,

        hover: {
          color: '#fff',
          background: '#28292b',
        },
      }}
      css={css`
        min-height: 30px;
      `}
      onClick={() => {
        setImageLibrary(!imageLibrary);
      }}
    />
  );
};

const currentLink = (() => {
  let $;
  return link => {
    return link || link === null ? ($ = link) : $;
  };
})();

const EditImage = ({ block, type = null }) => {
  const [imageLibrary, setImageLibrary] = useState(false);
  const [assetLibrary, setAssetLibrary] = useState(false);

  const description = useRef(null);

  const properties = {
    src: '',
    imageId: '',
    borderStyle: 'rectangle',
    fit: 'fill',
    fixedHeight: false,
    fixedHeightValue: 350,
    imgSize: 0,
    description: '',
    ...block.props,
  };
  const {
    src,
    imageId,
    borderStyle,
    fit,
    fixedHeight,
    fixedHeightValue,
    imgSize,
    description: desc,
    href,
    hrefInfo,
    linkData = {
      url: 'http://www.example.com',
      title: 'Describe where this link takes you',
      target: '_blank',
    },
  } = properties;

  const [showNavigationModal, setShowNavigationModal] = useState(false);
  const [modal, showModal] = useState(false);
  const [showModuleNavigation, setShowModuleNavigation] = useState(false);
  // const [linkData, setLinkData] = useState({} as any);

  const { getCurrentLinkAttribute, getValue } = helpers(
    {},
    () => {},
    linkData,
    value => {
      console.log(value);
    }
  );

  const isTextAndImage = useMemo(() => {
    const currentInteractionBlock: any = getBlockById(
      getState().currentInteraction
    );
    return currentInteractionBlock?.meta.subType === 'TextAndImage';
  }, []);

  const FileUploader_ = () => (
    <FileUploader
      label="Image Library"
      btnColor={lGrey0}
      onUploadComplete={result => {
        const url =
          (result && result.url) ||
          imageUploadError ||
          `https://loremflickr.com/1280/1024/lego?random=${Math.random()}`;

        setBlock(block, { src: url, imageId: result.id });
      }}
      style={{
        minWidth: 155,
        minHeight: 30,
        border: '1px solid #28292b',
        background: '#fff',
        fontSize: 10,
        color: '#28292b',
        hover: {
          color: '#fff',
          background: '#28292b',
        },
      }}
    />
  );

  const Option = key => ({ innerRef, innerProps, ...props }) => {
    const { value, label } = props;

    return (
      <div
        ref={innerRef}
        {...innerProps}
        css={css`
          display: flex;
          align-items: center;
          height: 35px;
          padding: 0 10px;
          font-size: 12px;
          font-weight: ${properties[key] === value ? 500 : 200};
          cursor: pointer;
          pointer-events: ${properties[key] === value ? 'none' : 'auto'};
          &:hover {
            background: #deebff;
          }
        `}
        onClick={e => {
          setBlock(block, { [key]: value });
        }}
      >
        {label}
      </div>
    );
  };

  const borderStyles = {
    circle: 'Circle',
    rectangle: 'Rectangle',
    roundedRectangle: 'Rounded rectangle',
  };

  const fits = {
    fill: 'Fill',
    contain: 'Contain',
    cover: 'Cover',
  };

  if (type && type === 'logo') {
    return (
      <div
        css={css`
          margin: 20px 0;
        `}
      >
        {/* <FileUploader_ /> */}
        <ImageLibraryBtn
          imageLibrary={imageLibrary}
          setImageLibrary={setImageLibrary}
        />
        <Panel
          title="Image description"
          info="Give your image a description for screen readers."
          css={css`
            font-size: 12px;
          `}
        >
          <Input
            defaultValue={desc}
            update={value => {
              setBlock(block, { description: value });
            }}
          />
        </Panel>

        {imageLibrary && (
          <ImageLibraryContext.Provider
            value={{
              onAddImage(result) {
                setBlock(block, { src: result.url, imageId: result.id });
              },
              onClose() {
                setImageLibrary(!imageLibrary);
              },
              currentImageSrc: src,
              currentImageId: imageId,
              cacheSelected: {
                yourLibrary: null,
                chameleonsLibrary: 0,
              },
              cacheFilter: {
                value: '',
              },
            }}
          >
            <ImageLibrary />
          </ImageLibraryContext.Provider>
        )}
      </div>
    );
  }

  return (
    <div>
      <SetMediaType block={block} mediaParent={getMediaParent(block.id)} />

      <div
        css={css`
          display: flex;
          align-items: center;
          margin: 20px 0;
        `}
      >
        {/* <FileUploader_ /> */}
        <ImageLibraryBtn
          imageLibrary={imageLibrary}
          setImageLibrary={setImageLibrary}
        />
      </div>

      <Panel
        title="Shape"
        info="Set the border shape of your image."
        css={css`
          font-size: 12px;
        `}
      >
        <Select
          key={borderStyle}
          placeholder={borderStyles[borderStyle] || 'Select'}
          options={Object.keys(borderStyles).map((e, i) => ({
            value: e,
            label: borderStyles[e],
          }))}
          components={{ Option: Option('borderStyle') }}
        />
      </Panel>

      <Panel
        title="Image fit"
        info="Set the position of the image within the frame."
        css={css`
          font-size: 12px;
        `}
      >
        <Select
          key={fit}
          placeholder={fits[fit] || 'Select'}
          options={Object.keys(fits).map((e, i) => ({
            value: e,
            label: fits[e],
          }))}
          components={{ Option: Option('fit') }}
        />
      </Panel>

      {isTextAndImage && (
        <Panel
          title="Image size"
          info="Increase the default size of your image by the selected value."
          css={css`
            font-size: 12px;
          `}
        >
          <NumberPicker_v2
            label="Value"
            value={imgSize}
            increment={5}
            onChange={value => {
              setBlockProps(block, { imgSize: value });
            }}
          />
        </Panel>
      )}

      <Panel
        title="Image description"
        info="Give your image a description for screen readers."
        css={css`
          font-size: 12px;
        `}
      >
        <Input
          defaultValue={desc}
          update={value => {
            setBlock(block, { description: value });
          }}
        />
      </Panel>

      {isFeatureEnabled(FeatureFlag.AddESVGImage) && (
        <React.Fragment>
          {/* <div
            css={css`
              margin: 20px 0 0 0;
              font-size: 12px;
              font-weight: 700;
              cursor: pointer;
              &:hover {
                opacity: 0.8;
              }
            `}
            onClick={() => setImageLibrary(!imageLibrary)}
          >
            IMAGE LIBRARY
          </div> */}
          {imageLibrary && (
            <ImageLibraryContext.Provider
              value={{
                onAddImage(result) {
                  // console.log(result);
                  const { url, id, width, height } = result;
                  setBlock(block, { src: url, imageId: id, width, height });
                },
                onClose() {
                  setImageLibrary(!imageLibrary);
                },
                currentImageSrc: src,
                currentImageId: imageId,
                cacheSelected: {
                  yourLibrary: null,
                  chameleonsLibrary: 0,
                },
                cacheFilter: {
                  value: '',
                },
              }}
            >
              <ImageLibrary />
            </ImageLibraryContext.Provider>
          )}

          <div style={{ margin: '15px 0 0 0', fontSize: 12 }}>
            <_>
              <Info info={'Click Navigation to add a hyperlink to your image.'}>
                Hyperlink
              </Info>
              <span style={{ color: mint }}>
                {/* {console.log(
                  linkData.url,
                  getLocationName(linkData.url.replace('#', ''))
                )} */}
                {linkData.url &&
                  (getLocationName(linkData.url.replace('#', '')) || []).join(
                    '/'
                  )}
              </span>
            </_>

            <div
              onClick={() => {
                showModal(true);
                // // setShowNavigationModal(true)}>
              }}
            >
              <H2_v2
                css={css`
                  color: #98add9;
                  margin: 10px 0 0 0;
                  text-decoration: underline;
                  cursor: pointer;

                  &:hover {
                    opacity: 0.8;
                  }
                `}
              >
                Navigation
              </H2_v2>
            </div>
          </div>

          {modal && (
            <Modal onClose={() => showModal(false)}>
              <div
                css={css`
                  position: relative;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  width: 100%;
                  padding: 50px;
                `}
                onClick={e => e.stopPropagation()}
              >
                {!showModuleNavigation && (
                  <_>
                    <div
                      css={css`
                        position: absolute;
                        right: 20px;
                        top: 20px;
                      `}
                    >
                      <CloseBtn
                        color={lGrey0}
                        onClick={() => showModal(false)}
                      />
                    </div>

                    <h4
                      css={css`
                        margin-bottom: 15px;
                        font-weight: 500;
                      `}
                    >
                      Enter destination URL
                    </h4>

                    <InputRow
                      label="URL"
                      property="url"
                      value={linkData.url}
                      onUpdate={value => {
                        // console.log(value);
                        setBlockProps(block, {
                          linkData: {
                            ...linkData,
                            ...value,
                          },
                        });
                      }}
                    />

                    <InputRow
                      label="Link title"
                      property="title"
                      value={linkData.title}
                      onUpdate={value => {
                        console.log(value);
                        setBlockProps(block, {
                          linkData: {
                            ...linkData,
                            ...value,
                          },
                        });
                      }}
                    />

                    <div>
                      <EditorBtn
                        label={
                          linkData.url === getCurrentLinkAttribute('href') &&
                          linkData.title === getCurrentLinkAttribute('title') &&
                          linkData.target === getCurrentLinkAttribute('target')
                            ? 'remove'
                            : 'add link'
                        }
                        style={{
                          width: 200,
                          marginTop: 25,
                          textTransform: 'uppercase',
                        }}
                        onClick={e => {
                          const { url, title } = linkData;
                          //
                          if (
                            e.currentTarget.innerText.toLowerCase() === 'remove'
                          ) {
                            setBlockProps(block, { linkData: {} });
                            return;
                          }

                          // if (!isURL(url)) return alert(`${url} is not a valid url.`);

                          let target = '_blank';

                          if (linkData.url.charAt(0) === '#') {
                            target = '_self';
                          }

                          if (linkData.url.includes('mailto:')) {
                            target = '_self';
                          }

                          setBlockProps(block, {
                            linkData: {
                              ...linkData,
                              target,
                            },
                          });
                          //
                          showModal(false);
                        }}
                      />
                    </div>

                    <div
                      css={css`
                        margin: 25px 0 0 0;
                        color: #98add9;
                        text-decoration: underline;
                        cursor: pointer;
                        font-size: 12px;

                        &:hover {
                          opacity: 0.8;
                        }
                      `}
                      onClick={() => {
                        setShowModuleNavigation(true);
                      }}
                    >
                      Link to a location within the module.
                    </div>
                  </_>
                )}

                {showModuleNavigation && (
                  <ModuleNavigation
                    noActions
                    location={linkData.url ? linkData.url.replace(/#/, '') : ''}
                    setLocation={location => {
                      console.log({ location });
                      setBlockProps(block, {
                        linkData: {
                          ...linkData,
                          url: `#${location}`,
                          target: '_self',
                        },
                      });
                    }}
                    onClose={() => setShowModuleNavigation(false)}
                  />
                )}
              </div>
            </Modal>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

export default EditImage;
export { ImageLibraryContext };
